import { mutations } from '@/store/modules/map/mutations';
import { actions } from '@/store/modules/map/actions';
import basemapLayers from '@/services/map-services/basemap-options';
import { getters } from '@/store/modules/map/getters';
import { Err } from 'ts-results';
import { createSelectionLayer } from '@/services/map-services/layers';
export const menuItems = {
    FindData: 'Find Data',
    ActiveLayers: 'Active Layers',
    DataTables: 'Data Tables',
    Basemaps: 'Basemaps',
    Legend: 'Legend',
};
const state = {
    sidebar: {
        activeMenuItem: '',
    },
    sidetray: {
        title: '',
        active: false,
    },
    bottomDrawer: {
        title: '',
        active: false,
        attributeTableResult: Err('No layer selected.'),
    },
    basemaps: basemapLayers,
    layers: [],
    time: {
        timeEnabled: false,
    },
    ol: {
        home: {
            center: undefined,
            zoom: undefined,
        },
        map: undefined,
        view: undefined,
        selectionLayer: createSelectionLayer(),
        layers: [],
    },
};
export const ExplorerMap = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
